export const tabList = [
	{
		flag: 'dispatchTable',
		text: 'For dispatch',
		url: '/reports'
	},
	{
		flag: 'safetyTable',
		text: 'For safety',
		url: '/reports/safety'
	},
	{
		flag: 'billingTable',
		text: 'For billing',
		url: '/reports/billing'
	},
];
